import React, { useRef, memo } from 'react';
import { useTranslation } from 'react-i18next';

import useSidePaddingsOnHorizontalScroll from 'hooks/useSidePaddingsOnHorizontalScroll';
import Image from 'components/image';
import { TGame, Feature } from 'types';
import './styles.scss';

interface IGameFeatures {
  game: TGame;
}

const MAX_CHARACTERS_IN_SUBTITLE_PER_LINE = 10;

const GameFeatures: React.FC<IGameFeatures> = ({ game }) => {
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);

  useSidePaddingsOnHorizontalScroll(ref);

  return (
    <>
      <p className="heading p-side">{t('features')}</p>
      <div className="flex mb2 overflow-x-scroll scrollable-gutters no-scroll" ref={ref}>
        {game.features.map((feature: Feature) => (
          <div key={feature.title + feature.subtitle} className="feature flex-col flex items-center">
            <Image className="mb1" src={feature.logoURL} />
            {feature.title && <div className="title">{feature.title}</div>}
            {feature.subtitle && (
              <div
                className={`subtitle ${feature.subtitle.length > MAX_CHARACTERS_IN_SUBTITLE_PER_LINE ? 'w-min' : ''}`}
              >
                {feature.subtitle}
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default memo(GameFeatures);
